// extracted by mini-css-extract-plugin
export default {"sad":"mkEQNh6wADQk4ToZsG1P"};